import { render, staticRenderFns } from "./CriarGrupoModal.vue?vue&type=template&id=3fc794f9&scoped=true"
import script from "./CriarGrupoModal.vue?vue&type=script&lang=js"
export * from "./CriarGrupoModal.vue?vue&type=script&lang=js"
import style0 from "./CriarGrupoModal.vue?vue&type=style&index=0&id=3fc794f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc794f9",
  null
  
)

export default component.exports